export type FeatureFlagCookies = (
  | string
  | {
      name: string
      value: string
    }
)[][]

export const getFeatureFlagCookieOverride = (flagKey: string, cookies: FeatureFlagCookies) => {
  const parsedCookies = Array.from(cookies)
    .flat()
    .filter(entry => typeof entry === 'object') as { name: string; value: string }[]

  const cookieFlagOverride = parsedCookies?.find(cookie => cookie.name === flagKey)

  if (!cookieFlagOverride) {
    return null
  }

  return cookieFlagOverride.value.toLowerCase() === 'true'
}
